"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H4"));

var _H2 = _interopRequireDefault(require("UIComponents/elements/headings/H5"));

var displayName = 'PropertyFormHeader';
var propTypes = {
  centerPropertyForm: _propTypes.default.bool,
  userTimezone: _propTypes.default.string.isRequired,
  dateTime: _propTypes.default.number.isRequired,
  offline: _propTypes.default.bool.isRequired
};

var PropertyFormHeader = function PropertyFormHeader(_ref) {
  var centerPropertyForm = _ref.centerPropertyForm,
      offline = _ref.offline,
      userTimezone = _ref.userTimezone,
      dateTime = _ref.dateTime;
  var suffix = offline ? 'offline' : 'online';
  var headerClasses = (0, _classnames.default)('p-x-1 m-bottom-4', {
    'p-x-15 p-top-23': centerPropertyForm
  });
  return _react.default.createElement("div", {
    className: headerClasses,
    "data-timestamp": dateTime,
    "data-selenium-test": "property-form-header"
  }, _react.default.createElement(_H.default, {
    className: "m-bottom-3"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "prebook.details.confirm." + suffix
  })), _react.default.createElement(_H2.default, {
    className: "m-bottom-0"
  }, dateTime ? _I18n.default.moment(dateTime).tz(userTimezone).format('LLLL') : ''));
};

PropertyFormHeader.displayName = displayName;
PropertyFormHeader.propTypes = propTypes;
var _default = PropertyFormHeader;
exports.default = _default;
module.exports = exports.default;